<template>
    <div :id="match.id" class="Match" :class="{ 'OOP-match__holder--f' : followed(match.notBefore) }">

        <div class="Match__head__time generic-small" :class="{'emptyNotBefore' : !displayNotBefore(match.notBefore) }">
            {{displayNotBefore(match.notBefore)}}
        </div>

        <div class="Match__body">

            <div class="Match__head generic-small">
                <div class="Match__head__type">
                    {{eventType(match.id)}}
                </div>
                <div class="Match__head__bottom">
                    <div class="Match__head__court" v-if="courtDisplay(court.id)">
                        {{courtDisplay(court.id)}} - {{roundName(match.id)}}
                    </div>
                    <div class="Match__head__court" v-else>
                        {{courtDisplay(court)}} - {{roundName(match.id)}}
                    </div>

                    <div class="Match__head__state">
                        {{displayStatus(match)}}
                    </div>
                </div>

            </div>

            <div v-for="team in match.team" class="Match__line" :class="{ 'reverse': shouldReverse(match) == true }">

                <div class="Match__player__holder">

                    <div v-for="player in team.players" class="Match__player"
                         :data-id="player.id" v-if="player.id != 'TBD' && team.playersKnown == true">

                        <img v-if="player.country" class="small-flag" :src="flagPath + player.country.toLowerCase() + '.svg'"
                             :alt="player.country">

                         <span class="Match__player__fn generic-medium">{{ player.first }}</span><span class="Match__player__i generic-medium">{{initial(player.first)}}</span>&nbsp;<span
                             class="Match__player__ln generic-medium">{{ player.last }}</span>

                          <span class="Match__player__seed" v-if="team.seed">[{{ team.seed }}]</span>
                          <span class="Match__player__seed" v-if="showType( 'wc', player.id )">[WC]</span>


                    </div>

                    <div class="Match__player" v-else-if="team.teamCode == 'Alternate'">
                       Alternate
                   </div>

                    <div class="Match__player" v-else>TBD</div>

                </div>

                <div class="Match__set generic-medium">
                    <ul>
                        <li>-</li>
                        <li>-</li>
                        <li>-</li>
                    </ul>

                </div>

            </div>

        </div>

        <div class="Match__meta">

            <div class="Match__time general-button grey-blue generic-small pdf_downloads">
                <span v-html="ico_clock"></span>
                00:00
            </div>


            <a class="Match__link general-button grey-blue generic-small pdf_downloads" :href="detail + '?match=' + match.id" v-if="showStat(match) && !isJuniors(match)">
                Match Stats
            </a>

            <a class="Match__link general-button grey-blue generic-small pdf_downloads" :href="ticket" v-else-if="!showStat(match)">
                Get tickets
            </a>

            <div class="Match__na" v-else>
                 Not available
            </div>

        </div>


    </div>
</template>

<script>

    import moment from 'moment'

    export default {
        props: ['match', 'flagPath', 'type', 'detail', 'ticket', 'court'],
        data() {
            return {
                // ico_pointer_right: ico_pointer_right,
                // ico_ticket: ico_ticket,
                ico_clock  : window.ico_clock
            }
        },
        methods: {
            showStat(match) {

                return this.determineShowStat(match)

            },
            determineStatus(match) {
                // console.log(match.id, match.team[0].players[0].id)
                if (match.status == 'Finished') {
                    return match.status
                }

                if (match.detail == '' || match.detail.state == 'upcoming') {
                    return 'Upcoming'
                }

                if (match.detail.state == 'W' ) {
                    return 'Warmup'
                }

                if (match.detail.state == 'C') {
                    return 'On court'
                }

                if (match.detail.state == 'F') {
                    return 'finished'
                }

                if (match.detail.state == 'P') {
                    return 'in progress'
                }

                if (match.detail.state == 'M') {
                    return 'in progress'
                }

                if (match.detail.state == 'S') {
                    return 'Suspended'
                }

                if (match.detail.state == 'G') {
                    return 'Players Arrived'
                }

                if (match.detail.state == 'T') {
                    return 'Time Announcement'
                }

                return '-'



            },
            displayStatus(match) {

                return this.determineStatus(match)

            },
            determineShowStat(match) {

                if (match.status == 'Finished') {
                    return true
                }

                if (match.detail.state == 'F' || match.detail.state == 'P') {
                    return true
                }

                return false
            },
            isJuniors(){
                let code = this.match.id.substring(0,2).toLowerCase();
                if(code == 'bq' || code == 'bs' || code == 'bd' || code == 'gq' || code == 'gs' || code == 'gd'){
                    return true
                }else{
                    return false
                }

            },
            displayNotBefore(notBefore) {
                if(notBefore){
                    if (notBefore.text == notBefore.time) {
                        return notBefore.time
                    }

                    if(notBefore.time == '' && notBefore.isoTime != '' ){
                        return notBefore.text + ' ' + this.parseTime(notBefore.isoTime)
                    }

                    if(notBefore.isoTime != '' && notBefore.text != ''){
                        return notBefore.text + ' ' + this.parseTime(notBefore.isoTime)
                    }

                    if (notBefore.text == 'Not Before' && notBefore.time != '') {
                        return notBefore.time
                    }

                    return `${notBefore.text}  ${notBefore.time}`
                }else{
                    return false
                }



            },
            parseTime( isoTime ){
                var time = new moment(isoTime, 'HH:mm:ss')

                return time.format( 'h:mm a' )
            },
            followed(notBefore) {

                if (notBefore.text == 'Followed By') {
                    return true
                }

                return false

            },
            finished(match) {


                if (match.status == 'Finished') {
                    return true
                }

                if (match.detail != '' && match.detail.state == 'F') {
                    return true
                }

                return false

            },
            courtDisplay(courtId) {

                let courts = window.court_stadium

                courts = courts.filter(function(court) {
                    return court.court_id == courtId
                })

                if ( courts.length > 0 ) {
                    return courts[0].stadium_name
                }

                return courtId

            },
            eventType(matchID){
                if(matchID.includes('MS')){
                    return "Men's Singles"
                }else if(matchID.includes('MD')){
                    return "Men's Doubles"
                }else if(matchID.includes('QS')){
                    return "Men's Qualifying"
                }else if(matchID.includes('LS')){
                    return "Women's Singles"
                }else if(matchID.includes('LD')){
                    return "Women's Doubles"
                }else if(matchID.includes('RS')){
                    return "Women's Qualifying"
                }
            },
            roundDisplay(round) {
                if (round == '1' || round == 'R32' || round == 'First Round')
                    return 'Round 1'
                else if (round == '2' || round == 'R16' || round == 'Second Round')
                    return 'Round 2'
                else if (round == '3')
                    return 'Round 3'

                if (this.type == 'wta') {

                    if (round == 'Q')
                        return 'Quarterfinals'
                    else if (round == 'S')
                        return 'Semifinals'
                    else if (round == 'F')
                        return 'Final'
                } else {
                    if (round == '5')
                        return 'Quarterfinals'
                    else if (round == '6')
                        return 'Semifinals'
                    else if (round == '7')
                        return 'Final'
                }

                if(round == 'F')
                    return 'Final'

                if ( round == 'Q1' || round == 'R1' )
                    return 'Round 1'
                else if ( round == 'Q2' || round == 'R2' || round == "Q4" )
                    return 'Round 2'

                return round;
            },
            initial(name) {
                return `${name.charAt(0)}.`
            },
            shouldReverse(match) {

                if ( match.detail.winner == undefined || match.detail.winner == '0' ) {
                    return false
                }

                if ( match.detail.winner == '2' || match.detail.winner == '4' || match.detail.winner == '6' ) {
                    return false
                }

                if( match.detail.winner == match.team[0].players[0].id) {
                    return false
                }

                return true
            },
            findPlayerById( playerId ) {
                if ( playerId == '' )
                    return false

                let found = window.all_players.filter(player => player.player_id == playerId)

                if (found.length >= 1)
                    return found[0]

                return false
            },
            showType( type, playerId ) {
                let player = this.findPlayerById( playerId )

                if ( type == 'wc' && player.is_wild_card == true )
                    return true

                return false;
            },
            roundName(matchId){

                const idNumber = parseInt(matchId.slice(2), 10);
                var round = ""

                if(matchId.toLowerCase().includes('ls') || matchId.toLowerCase().includes('ms')){
                    round = 'Final'

                    if(idNumber >= 2){
                        round = 'Semifinals'
                    }
                    if(idNumber >= 4){
                        round = 'Quarterfinals'
                    }
                    if(idNumber >= 8){
                        round = 'Round 3'
                    }
                    if(idNumber >= 16){
                        round = 'Round 2'
                    }
                    if(idNumber >= 32){
                        round = 'Round 1'
                    }

                }else if(matchId.toLowerCase().includes('ld') || matchId.toLowerCase().includes('md')){
                    round = 'Final'

                    if(idNumber >= 2){
                        round = 'Semifinals'
                    }
                    if(idNumber >= 4){
                        round = 'Quarterfinals'
                    }
                    if(idNumber >= 8){
                        round = 'Round 2'
                    }
                    if(idNumber >= 16){
                        round = 'Round 1'
                    }

                }else if(matchId.toLowerCase().includes('rs') || matchId.toLowerCase().includes('qs')){

                    round = 'Round 2'
                    if(idNumber >= 16){
                        round = 'Round 1'
                    }

                }

                return round;
            }

        }
    }
</script>
